var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"23fff9b4c77ff3e4d93035a3c3f529e603af811e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["paygibdd-nuxt@sentry"]={id:"23fff9b4c77ff3e4d93035a3c3f529e603af811e"};
      